import { __rest, __assign } from 'tslib';
import * as React from 'react';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { useComponentBlockComponent } from './ComponentBlockContext.esm.js';

var ComponentBlock = function (_a) {
    var id = _a.id, _b = _a.fields, componentName = _b.componentName, internalName = _b.internalName, analyticsEvents = _b.analyticsEvents, dataCy = _a["data-cy"], props = __rest(_a, ["id", "fields", 'data-cy']);
    var _c = useComponentBlockComponent(componentName), Component = _c.Component, isSection = _c.isSection;
    if (!Component) {
        console.warn("No component registered for ".concat(componentName, " - please use ComponentBlockContext to provide component mapping"));
        return null;
    }
    if (!isSection) {
        return React.createElement(Component, { id: id });
    }
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement(Component, __assign({ id: id }, props))));
};

export { ComponentBlock as default };
//# sourceMappingURL=ComponentBlock.esm.js.map
